import * as React from 'react';
import { ButtonColorUnion } from 'components/Button';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import { NamedInterlocutor, pushRouterToChatWithMember } from 'lib/ChatRouteHelper';

type Props = {
  // callback called when the router transition is performed
  onTransitionStart?: () => Promise<any>;
  // if disabled, do not wrap into link and ignore clicks.
  disabled?: boolean;
  // the color of the <Link>
  color?: ButtonColorUnion | 'inherit';
  // children
  children: React.ReactNode;
  // a named interlocutor
  user: NamedInterlocutor;
};

class IndividualChatStarter extends React.Component<Props> {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  go = () => {
    return pushRouterToChatWithMember(this.context.router, this.props.user).then(
      this.props.onTransitionStart
    );
  };

  render() {
    if (this.props.disabled) {
      return this.props.children;
    }

    return (
      <Link onClick={this.go} color={this.props.color}>
        {this.props.children}
      </Link>
    );
  }
}

export { IndividualChatStarter };
export default IndividualChatStarter;
